var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    width: "20px",
    height: "20px",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 10.146 3.612 C 9.951 3.808 9.951 4.124 10.146 4.32 L 12.293 6.466 L 6.5 6.466 C 6.224 6.466 6 6.69 6 6.966 C 6 7.242 6.224 7.466 6.5 7.466 L 12.293 7.466 L 10.146 9.612 C 9.951 9.808 9.951 10.124 10.146 10.32 C 10.342 10.515 10.658 10.515 10.854 10.32 L 13.854 7.32 C 14.049 7.124 14.049 6.808 13.854 6.612 L 10.854 3.612 C 10.658 3.417 10.342 3.417 10.146 3.612 Z",
    fill: "#232029",
    style: {
      transformOrigin: "10.0001px 6.966px"
    },
    transform: "matrix(0, 1.00001001358, -0.999989926815, 0, -6.41111e-7, -9.09676e-7)",
    color: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 5 5.274 C 5 3.893 6.119 2.774 7.5 2.774 L 14.5 2.774 C 14.776 2.774 15 2.998 15 3.274 C 15 3.55 14.776 3.774 14.5 3.774 L 7.5 3.774 C 6.672 3.774 6 4.446 6 5.274 L 6 15.274 C 6 16.102 6.672 16.774 7.5 16.774 L 14.5 16.774 C 14.776 16.774 15 16.998 15 17.274 C 15 17.55 14.776 17.774 14.5 17.774 L 7.5 17.774 C 6.119 17.774 5 16.655 5 15.274 L 5 5.274 Z",
    fill: "#232029",
    style: {
      transformOrigin: "10px 10.274px"
    },
    transform: "matrix(0, -1.00001001358, 0.999989926815, 0, 0.000001356525, -2.85619e-7)",
    color: "currentColor"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.04205ec2aa36653f53c0ea2b5555014f.svg";
export { ForwardRef as ReactComponent };